import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserGroupReducer } from '../reducers';

export const selectUserGroupFeature = createFeatureSelector<UserGroupReducer.DataState>(UserGroupReducer.featureName);

export const selectFeatureUserGroup = createSelector(selectUserGroupFeature, (state: UserGroupReducer.DataState) => state.detail);
